import { useLocation, useNavigate } from "react-router";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import AdminUsersTable from "../components/AdminUsers/Table";

const AdminUsers = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Container>
      <PageHeader
        title="Admin Kullanıcıları"
        isButtoned
        buttonText="Yeni Kullanıcı"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <AdminUsersTable />
    </Container>
  );
};

export default AdminUsers;
